import apiClient from "./axiosConfig";

export const getSpecialPlates = async () =>
    apiClient.feesAPI.get(`/api/v1/specialPlates/`);

export const createSpecialPlate = async (request) =>
    apiClient.feesAPI.post(`/api/v1/specialPlates/create`, request);

export const updateSpecialPlates = async (request) =>
    apiClient.feesAPI.put(`/api/v1/specialPlates/update`, request);
